export default "__VITE_ASSET__DVme84pn__"